import Vue from 'vue'
import Vuex from 'vuex'
import api from "@/config/api"
import {request} from "@/config/request";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dict: {},
    recipeDetail: {},
    userDetail: {}
  },
  getters: {
    getDictByFlag: state => flag => {
      let dict = state.dict[flag];
      return dict ? dict.dictItems : [];
    }
  },
  mutations: {
    CHANGE_DICT(state, dict) {
      state.dict = dict;
    },

    RECIPE_DETAIL(state, detail) {
      state.recipeDetail = detail;
    },
    USER_DETAIL(state, detail) {
      state.userDetail = detail;
    }
  },
  actions: {
    loadAllDict({commit}) {
      request(api.dict.list).then(res => {
        let dict = res.dictTypes;
        let dictMap = {};
        dict.forEach(t => {
          dictMap[t.flag] = t;
        })
        commit('CHANGE_DICT', dictMap);
      })
    },
  },
})
